// extracted by css-extract-rspack-plugin
export default {"overwriteActions":"overwriteActions-rgyDx6","nameInput":"nameInput-mfJLBG","saveActions":"saveActions-pqKpGF"};